






























































































import { Component, Vue } from 'vue-property-decorator';
import { validateEmail, validateNotEmpty } from '@/utils/form-validation';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import TitleContainer from '@/components/common/TitleContainer.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    TitleContainer,
    BeatLoader,
  },
  metaInfo(this: ResetPassword): MetaInfo {
    return {
      title: 'Reset Password |',
      meta: [
        ...seoDefault({
          title: 'Reset Password | Mysoalan',
          description:
            'Log in to your Mysoalan and start creating your exam or practice papers immediately.',
        }),
      ],
    };
  },
})
export default class ResetPassword extends Vue {
  userStore: UserStoreInterface = UserStore;

  mainTitle = [
    {
      type: 'highlight',
      value: 'Reset',
    },
    {
      type: 'normal',
      value: 'password',
    },
  ];

  mainP = ``;

  isLoading = false;

  emailInput = '';
  emailError: string | boolean = false;

  passwordInput = '';
  passwordError: string | boolean = false;

  retypePasswordInput = '';
  retypePasswordError: string | boolean = false;

  get token(): string {
    if (typeof this.$route.query.token === 'string') {
      return this.$route.query.token.trim();
    } else {
      return '';
    }
  }

  get hasToken(): boolean {
    return this.token && this.token !== '' ? true : false;
  }

  async requestResetSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;

    let hasError = false;

    if (!validateEmail(this.emailInput)) {
      this.emailError = 'Not valid email';
      hasError = true;
    } else {
      this.emailError = false;
    }

    if (this.hasToken) {
      if (!validateNotEmpty(this.passwordInput)) {
        this.passwordError = 'Password cannot empty';
        hasError = true;
      } else {
        this.passwordError = false;
      }

      if (!validateNotEmpty(this.retypePasswordInput)) {
        this.retypePasswordError = 'Password cannot empty';
        hasError = true;
      } else {
        this.retypePasswordError = false;
      }

      if (this.passwordInput !== this.retypePasswordInput) {
        this.passwordError = `Password not match`;
        this.retypePasswordError = `Password not match`;
        hasError = true;
      }

      if (this.passwordInput.length < 6) {
        this.passwordError = `Password must be at least 6 characters`;
        hasError = true;
      }
    }

    if (hasError) {
      this.isLoading = false;
      return;
    }

    if (this.hasToken) {
      await this.userStore.reset({
        email: this.emailInput,
        newPassword: this.passwordInput,
        token: this.token,
      });
    } else {
      await this.userStore.requestReset({
        email: this.emailInput,
      });
    }

    this.sendToast();
    this.redirectUser();
    this.isLoading = false;
    return;
  }

  sendToast() {
    if (this.userStore.error) {
      const error = this.userStore.error.message;
      this.$toasted.global.mainToast({
        message: `${error}`,
      });
    } else {
      if (this.hasToken) {
        this.$toasted.global.mainToast({
          message:
            'You have successfully change your password. Please sign in again.',
        });
      } else {
        this.$toasted.global.mainToast({
          message: 'We have sent you an email on how to reset your password.',
        });
      }
    }
  }

  redirectUser() {
    if (!this.userStore.error) {
      if (this.hasToken) {
        this.$router.push({
          name: 'signin',
        });
      } else {
        this.$router.push({
          name: 'home',
        });
      }
    }
  }

  signinClick() {
    this.$router.push({
      path: '/signin',
    });
  }
}
